import { Link } from 'react-router-dom';

export default function ServiciosTerreno() {
  const services = [
    {
      icon: 'ri-user-settings-line',
      title: 'Control de Cumplimiento',
      description: 'Supervisión continua del cumplimiento normativo en operaciones diarias.'
    },
    {
      icon: 'ri-alert-line',
      title: 'Gestión de Riesgos',
      description: 'Identificación y control de riesgos operacionales en tiempo real.'
    },
    {
      icon: 'ri-clipboard-line',
      title: 'Requerimientos del Mandante',
      description: 'Verificación del cumplimiento de exigencias específicas del cliente.'
    },
    {
      icon: 'ri-team-line',
      title: 'Acompañamiento Directo',
      description: 'Presencia física en terreno durante operaciones críticas.'
    },
    {
      icon: 'ri-file-list-line',
      title: 'Reportes Operacionales',
      description: 'Documentación inmediata de hallazgos y acciones correctivas.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Soporte HSE',
      description: 'Asesoría técnica permanente para el equipo operacional.'
    }
  ];

  return (
    <section id="asesoria-operacional" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Asesoría en Terreno
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Asesoría HSE <span className="text-teal-600">Operacional</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Acompañamos la operación en terreno, controlando cumplimiento, riesgos y requerimientos del mandante.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              
<img
  src="/images/services/asesoria-terreno-eolico.webp"
  alt="Servicios en Terreno"
  width={900}
  height={1100}
  loading="lazy"
  decoding="async"
  className="w-full h-full object-cover object-center"
/>

            </div>
            <div className="absolute -top-8 -right-8 bg-teal-600 rounded-xl p-6 shadow-xl max-w-xs">
              <div className="flex items-center gap-3 text-white">
                <i className="ri-map-pin-line text-3xl"></i>
                <div>
                  <div className="text-2xl font-bold">En Sitio</div>
                  <div className="text-sm text-white/90">Cuando lo necesitas</div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Presencia en terreno cuando la operación lo requiere
            </h3>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              Nuestro equipo de especialistas HSE se desplaza a tus instalaciones para acompañar operaciones críticas, verificar cumplimiento normativo y controlar riesgos en tiempo real. Trabajamos directamente con tu equipo operacional para asegurar que se cumplan todos los requerimientos del mandante.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Ofrecemos soporte técnico permanente durante la ejecución de trabajos de alto riesgo, auditorías de mandantes o cuando necesitas reforzar tu equipo HSE en terreno.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <strong className="text-gray-900">Respuesta inmediata:</strong>
                  <span className="text-gray-600"> Movilización rápida ante necesidades operacionales</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <strong className="text-gray-900">Control continuo:</strong>
                  <span className="text-gray-600"> Supervisión permanente durante operaciones críticas</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <strong className="text-gray-900">Documentación completa:</strong>
                  <span className="text-gray-600"> Reportes detallados de cada intervención</span>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <Link
                to="/contacto"
                className="bg-teal-600 text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors inline-flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
              >
                Solicitar asesoría en terreno
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all border border-gray-100 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}